import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  apiUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.apiUrl = `${baseUrl}api/`;
  }

  getComunidades(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}globals/comunidades`);
  }

  getProvincias(comunidadId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}globals/provincias/${comunidadId}`);
  }

}
